import { ILeanBrandTile } from "@faire/retailer-visitor-shared/components/LeanBrandTileRenderer/ILeanBrandTileAdapters";
import { PageLoadEvent } from "@faire/retailer-visitor-shared/services/performance/const";
import { PerformanceMarker } from "@faire/retailer-visitor-shared/services/performance/PerformanceMarker";
import { ProductCacheStore } from "@faire/retailer-visitor-shared/stores/domain/ProductCacheStore";
import { ICategoryPageResults } from "@faire/retailer-visitor-shared/views/category/__internal__/CategoryPageRoot/__internal__/LoggedInCategoryPage/__internal__/Base/__internal__/DataFetching/ICategoryPageResults";
import { StrictLocalizeFunction } from "@faire/web--source/common/localization";
import { isNotUndefined } from "@faire/web--source/common/typescriptUtils";
import { QueryParameters as BrandSearchParameters } from "@faire/web-api--source/endpoints/www/api/v2/search/brands/get";

export const fetchBrandFirstResults = async (
  request: BrandSearchParameters,
  { signal }: { signal: AbortSignal | undefined },
  strictLocalize: StrictLocalizeFunction
): Promise<ICategoryPageResults> => {
  PerformanceMarker.get().mark(PageLoadEvent.primaryFetchStart);
  const response = await ProductCacheStore.get().brandSearch(request, {
    signal,
  });
  PerformanceMarker.get().mark(PageLoadEvent.primaryFetchEnd);

  return {
    brands: response.brands
      .map(ILeanBrandTile.fromSearchV2IBrand(strictLocalize))
      .filter(isNotUndefined),
    formatted_total_primary_results_count:
      response.formatted_total_primary_results_count,
    visual_filter_options: response.visual_filter_options,
    pagination_data: response.pagination_data,
    request_id: response.request_id,
    filter_sections: response.filter_sections,
    product_tiles: undefined,
    retrieval_queries: [], // we don't use this for brand first results
    brand_page_query_params: undefined,
    brand_page_query_parameters: undefined,
    related_search_terms: [],
    more_in_c3: undefined,
  };
};
